module.exports = __webpack_public_path__ + "img/title.ebbdd78f.png";